import { ECUADOR_MAP_PACKS } from "../../../../../shared/ecuador-map-packs";
import { getStoredMapPack } from "../../../../lib/offline-maps";

const BUNDLED_LOCAL_CATALOG_ID = "ecuador";

/**
 * Returns only regional vector packs already persisted by THERA on this device.
 * The national id represents the gazetteer bundled inside the app, not a remote
 * map request. No map is downloaded or fetched by this discovery step.
 */
export async function discoverGeoArLocalPackIds(): Promise<readonly string[]> {
  if (typeof indexedDB === "undefined") return [BUNDLED_LOCAL_CATALOG_ID];

  const regionalPacks = ECUADOR_MAP_PACKS
    .filter((pack) => !pack.overview)
    .sort((left, right) => right.priority - left.priority || left.id.localeCompare(right.id));
  const downloaded = await Promise.all(regionalPacks.map(async (pack) => {
    const stored = await getStoredMapPack(pack.file).catch(() => undefined);
    return stored?.blob instanceof Blob && stored.blob.size > 0 ? pack.id : null;
  }));

  return [
    ...downloaded.filter((packId): packId is string => Boolean(packId)),
    BUNDLED_LOCAL_CATALOG_ID,
  ];
}
